export class Option {
    public id: string;
    public text: string;
    public option_id: number;
    public product_option_id: number;
    public sku: string;
    public price: number;
    public price_sign: string;
    public weight: number;
    public quantity: number;
    public weight_sign: string;
    public price_type: string;
    public image: string;
    public selected: boolean = false;
    public check_stock = true;
    constructor(item: Object) {
        Object.keys(item).forEach((prop) => {
            this[prop] = item[prop]
        });
        this.price = +this.price;
        this.weight = +this.weight;
        this.quantity = +this.quantity;
    }

    getAdditionalPrice(price: number): number {
        let addPrice = 0;
        switch (this.price_type) {
            case "F":
                if (this.price_sign == "+") {
                    addPrice = this.price;
                } else {
                    addPrice = this.price;
                    addPrice = 0 - this.price;
                }
                break;
            case "P":
                if (this.price_sign == "+") {
                    addPrice = price * this.price / 100;
                } else {
                    addPrice = price * this.price / 100;
                    addPrice = 0 - addPrice;
                }
                break;
        }
        return addPrice;
    }

    getAdditionalWeight(): number {
        let addWeight = 0;
        if (this.weight_sign == "+") {
            addWeight = this.weight;
        } else {
            addWeight = 0 - this.weight;
        }
        return addWeight;
    }

}



// WEBPACK FOOTER //
// ./src/bean/shop/option.ts